import React from 'react';
import BTechPrivacy from './BTech';
import KaafiPayPrivacy from './KaafiPay';
import { API_URL } from '../../constants/api';
import AlnasiibPrivacy from './Alnasiib';

// Import the specific privacy policy components

const PrivacyPolicy = () => {
  const hostname = API_URL;

  if (hostname.includes('bulshotech')) {
    return <BTechPrivacy />;
  } else if (hostname.includes('kaafipay')) {
    return <KaafiPayPrivacy />;
  }  else if (hostname.includes('alnasiib') || API_URL.includes('alnasiib')) {
    return <AlnasiibPrivacy />;
  } else {
    return <div>No matching privacy policy found for this domain.</div>;
  }
};

export default PrivacyPolicy;
